export const StationEvents = {
    maintenanceStationChannel: (stationId: number) => `maintenance-station.${stationId}`,
    presenceMaintenanceStationChannel: (stationId: number) => `presence-${StationEvents.maintenanceStationChannel(stationId)}`,

    stationConnected: () => 'station:connected',
    stationDisconnected: () => 'station:disconnected',

    chambersStartEdit: () => 'chambers:edit',
    chambersState: () => 'chambers:state',
    chambersSave: () => 'chambers:save',

    chambersSaveAck: () => 'chambers:save-ack',
    chambersSaveNack: () => 'chambers:save-nack',

    licenseKeySave: () => 'license-key:save',
    licenseKeySaveAck: () => 'license-key:save-ack',
    licenseKeySaveNack: () => 'license-key:save-nack',
};
